module.exports = __webpack_public_path__ + "static/media/acai_berry_cream.b800551c.png";